import '@/assets/styles/modal-signature.css'

import SignatureCanvas from 'react-signature-canvas'

import { Button } from '@/modules/shared/components/ui/button'
import {
	Dialog,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from '@/modules/shared/components/ui/dialog'


import { z } from 'zod'
import { Loader2 } from 'lucide-react'
import { useModalSignature } from './use-modal-signature.hook'

export function ModalSignatureComponent() {
	const {
		signatureRef,
		handleSaveSignature,
		handleClearSignature,
		isOpenModalSignatureOrder,
		isSavingOrder,
		handleCloseModalSignature,
	} = useModalSignature()

	return (
		<Dialog
			open={isOpenModalSignatureOrder}
			onOpenChange={handleCloseModalSignature}
		>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Assinatura</DialogTitle>
				</DialogHeader>

				<SignatureCanvas
					ref={signatureRef}
					velocityFilterWeight={1}
					penColor="black"
					canvasProps={{
						style: {
							width: '100%',
							height: '200px',
						},
						className: 'signature-canvas',
					}}
				/>

				<p className="text-center">Assinatura do cliente</p>

				<DialogFooter className='gap-2'>
					<Button variant="outline" onClick={handleClearSignature}>
						Limpar
					</Button>
					<Button onClick={handleSaveSignature} disabled={isSavingOrder}>
						{
							isSavingOrder && (
								<Loader2 size={20} className='mr-2' />
							)
						}
						Assinar
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
